import React from 'react'
import {Chart as ChartJS,CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,ArcElement,Legend} from 'chart.js'
import {Line,Doughnut} from 'react-chartjs-2'

ChartJS.register(CategoryScale,LinearScale,PointElement,LineElement,Title,Tooltip,ArcElement,Legend);

export const LineGraph = () => {
    const labels=getLastYearMonths();
    const options ={
        responsive : true,
        plugins:{
            legend:{
                position:'bottom'
            },
            title:{
                display:true,
                text:'Yearly views',
            },
        },
    };
    const data={
        labels,
        datasets:[
            {
                label:'views',
                data:[1,2,3,4],
                borderColor:'rgba(107,70,193,0.5)',
                backgroundColor:'#6b46c1'
            }
        ]
    }
  return (
    <Line options={options} data={data}/>
  )
}


export const DoughnutGraph = ()=>{
    const data={
        labels:['Subscribed','Not Subscribed'],
        datasets:[
            {
                label:'views',
                data:[4,8],
                borderColor:['rgba(62,12,171)','rgba(214,43,129)'],
                backgroundColor:['rgba(62,12,171,0.3)','rgba(214,43,129,0.3)'],
                borderWidth: 1,
            },
        ],
    };
    return <Doughnut data={data}/>
}


function getLastYearMonths(){
    const labels=[];
    const months=[
        'January',
        'February',
        'March',
        'April',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    const currMonth = new Date().getMonth();
    const remain = 11-currMonth;
    for(let i=currMonth;i<months.length;i--){
        const curr = months[i];
        labels.unshift(curr);
        if(i===0){break;}
    }
    for(let i=11;i>remain;i--){
        if(i===currMonth){break;}
        const curr = months[i];
        labels.unshift(curr);
    }
    return labels
}